import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider, FieldArray, getIn } from 'formik';
import { connect } from "react-redux";
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
// material
import {
    Card,
    Stack,
    TextField,
    Container,
    Typography,
    Grid,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { addAccount } from '../../actions/accountAction';
import _, { replace } from 'lodash';
import Page from '../../components/Page';
import { styled } from '@mui/material/styles';


// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
    maxWidth: 680,
    margin: 'auto',
    minHeight: '100vh',
    flexDirection: 'column',
    justifyContent: 'center',
}));

function AddAccount(props) {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [adminObj, setAdminObj] = useState({});
    const [openUpdate, setOpenUpdate] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);

    const AddSchema = Yup.object().shape({
        title: Yup.string().required('Title is required'),
        account_no: Yup.string().required('Account no is required'),
        bank_name: Yup.string().required('Bank Name is required'),
        branch_name: Yup.string().required('Branch Name is required'),
    });

    const formik = useFormik({
        initialValues: {
            title: '',
            account_no: '',
            bank_name: '',
            branch_name: ''
        },
    validationSchema: AddSchema,
        onSubmit: (values, {resetForm}) => {
            resetForm();
            setIsLoading(true);
            props.addAccount(values);
        }
    });

    useEffect(() => {
        setIsLoading(false);
        if(props.alerts.status == 'success') {
            props.onDismis();
        }
    }, [props.alerts]);

    const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, handleChange, handleBlur } = formik;

    return (
        <Page title="Add Car Detail">
            <Container maxWidth="lg">
                <Card sx={{padding:"1em"}}>
                    <FormikProvider value={formik}>
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            label="Title*"
                                            {...getFieldProps('title')}
                                            error={Boolean(touched.title && errors.title)}
                                            helperText={touched.title && errors.title}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                    <TextField
                                            fullWidth
                                            type="text"
                                            label="Account no*"
                                            {...getFieldProps('account_no')}
                                            error={Boolean(touched.account_no && errors.account_no)}
                                            helperText={touched.account_no && errors.account_no}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            label="Bank Name*"
                                            {...getFieldProps('bank_name')}
                                            error={Boolean(touched.bank_name && errors.bank_name)}
                                            helperText={touched.bank_name && errors.bank_name}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            label="Branch Name*"
                                            {...getFieldProps('branch_name')}
                                            error={Boolean(touched.branch_name && errors.branch_name)}
                                            helperText={touched.branch_name && errors.branch_name}
                                        />
                                    </Grid>
                                </Grid>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
                            </Stack>

                            <LoadingButton
                                size="medium"
                                type="submit"
                                variant="contained"
                                loading={isLoading}
                                sx={{backgroundColor: '#c29136',float:"right"}}
                            >
                                Add
                            </LoadingButton>
                        </Form>
                    </FormikProvider>
                </Card>
            </Container>
        </Page>
    );
}
const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        alerts: state.alerts,
    }
}

export default connect(mapStateToProps, { addAccount })(AddAccount);

